<template>
    <b-dropdown-group>
        <slot />
    </b-dropdown-group>
</template>

<script>
import { BDropdownGroup } from 'bootstrap-vue'

export default {
    components: { BDropdownGroup },
}
</script>